export default __webpack_public_path__ + "static/media/clipboard.5a57f262.svg";